/**
 * @ngdoc component
 * @name common.component:itxBanners
 * @description
 * Orquestador de banners.
 * Abrira las modales respetando criterios especificos. Luego el servicio decidira cuando
 * se mostrara cada una dependiendo si tiene dependencias en otras.
 */
(function () {
    'use strict';

    var itxBanners = {
        bindings: {
            onBannerClose: '&'
        },
        controller: itxBannersCtrl,
        templateUrl: 'banners.component.html'
    };

    itxBannersCtrl.$inject = ['BannersService', 'ItxScreenSizeSvc', 'NavigationService'];

    function itxBannersCtrl(BannersService, ItxScreenSizeSvc, NavigationService) {
        var _this = this;

        _this.$onInit = function () {
            _this.BannersService = BannersService;
            _this.BannersService.verifyGeoblockingStore();

            BannersService.openBanner(BannersService.banners.marketing.value);
            /* // Abrira banner de descargate la APP solo en dispositivos mobiles.
            if (ItxScreenSizeSvc.isDeviceMobile() && NavigationService.isCategoryPage()) {
                BannersService.openBanner(BannersService.banners.downloadApp.value);
            } */
            if (BannersService.canIOpenBannersInApollo()) {
                BannersService.activateApolloBanners();
            }

            // Abrira banner de marketing solo en la home y en paginas de categorias.
            // if (['ItxHomePage', 'ItxCategoryPage'].indexOf(inditex.iPage) >= -1) {
            // }
            BannersService.isWebApp();
        };

        document.addEventListener('optimize:showBanner', function (e) {
            BannersService.openBanner(e.detail.type);
        });

        /**
         * Función que se ejecuta al cerrar un banner
         */
        _this.closeBanner = function (banner, hideBannerNextTime) {
            if (banner === 'redirect') {
                localStorage.setItem('last-geoblocking-store-id', inditex.iStoreId);
            }
            BannersService.closeBanner(banner, hideBannerNextTime);
            if (!BannersService.isSomeBannerInQueue()) {
                BannersService.activateApolloBanners();
            }
        };

        _this.handleStoreConfirmation = function (accepted) {
            localStorage.setItem('last-geoblocking-store-id', inditex.iStoreId);
            if (!accepted) {
                localStorage.setItem('last-geoblocking-rejected', true);
            } else {
                BannersService.saveLastStore();
            }

            BannersService.closeBanner(BannersService.banners.ask.value, accepted);
            if (!BannersService.isSomeBannerInQueue()) {
                BannersService.activateApolloBanners();
            }
            _this.onBannerClose({
                bannerType: BannersService.banners.ask.value,
                action: {
                    saveStore: accepted
                }
            });
        };
    }

    angular.module('itxApp.common').component('itxBanners', itxBanners);
})();
